import { useState } from 'react';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useFieldContext } from '#form';
import { formatISO, isValid } from 'date-fns';

import { LabelInput } from '@repo/ui/LabelInput';

export function DateOfLossInput() {
	const field = useFieldContext<string | null>();
	const { errors } = field.state.meta as {
		errors?: string[];
	};
	const [draftValue, setDraftValue] = useState<Date | null>(null);

	const displayValue =
		draftValue ??
		(typeof field.state.value === 'string' ?
			new Date(field.state.value.split('T')[0]! + 'T00:00')
		:	null);

	return (
		<LabelInput label="Date of Loss" fieldName={field.name}>
			<DatePicker
				value={displayValue && isValid(displayValue) ? displayValue : null}
				onChange={(e: Date | null, context) => {
					setDraftValue(e);
					if (e && isValid(e) && !context.validationError) {
						field.handleChange(
							formatISO(e, {
								representation: 'date',
							}),
						);
						setDraftValue(null);
					}
				}}
				slotProps={{
					field: {
						clearable: true,
						onClear: () => {
							field.handleChange(null);
							setDraftValue(null);
						},
					},
					textField: {
						helperText: errors?.[0],
						error: !!errors?.length,
						id: field.name,
					},
				}}
			/>
		</LabelInput>
	);
}
